import { createAction } from 'redux-act';
import { ICheckoutFlowReducer } from 'modules/ScrShop/store/types';

export const setCheckOutFlowAction = createAction<Partial<ICheckoutFlowReducer>>();

export const cleanUpCheckoutFlowAction = createAction();
